<ng-container *ngIf="category">
  <div class="page-title">
    Detalhes da categoria -
    {{ categorySummary?.externalIdString }} {{ category.displayName }}
  </div>
  <div class="details category-details">
    <div class="details__right">
      <div class="card">
        <p-tabView
          [activeIndex]="selectedTab"
          (activeIndexChange)="tabChanged($event)"
        >
          <p-tabPanel header="Informações gerais">
            <div class="basic-details">
              <app-product-category-form
                *ngIf="categories && childrenCategories"
                [model]="category"
                (updated)="updateCategory($event)"
                [categories]="categories"
                [children]="childrenCategories.length > 0"
              />
              <app-categories-tree-table
                *ngIf="childrenCategories?.length"
                [categories]="childrenCategories"
                [addButton]="false"
              />
            </div>
          </p-tabPanel>
          <p-tabPanel header="Produtos ({{ products?.length || 0 }})">
            <app-table
              *ngIf="products && productCols"
              [elements]="products"
              [cols]="productCols"
              [addButton]="false"
              [lazy]="false"
              sortField="productName"
              [sortOrder]="-1"
              modelName="produtos"
              [dropdownFilters]="dropdownFilters()"
              [changeColumns]="true"
            />
          </p-tabPanel>
          <p-tabPanel header="Variantes ({{ productVariants?.length || 0 }})">
            <app-table
              *ngIf="productVariants && variantCols"
              [elements]="productVariants"
              [cols]="variantCols"
              [addButton]="false"
              [lazy]="false"
              sortField="productVariantName"
              [sortOrder]="-1"
              modelName="variantes"
              [changeColumns]="true"
            />
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</ng-container>

<div class="category-form" *ngIf="!category">
  <div class="page-title">Nova categoria</div>
  <app-product-category-form [categories]="categories" *ngIf="categories" />
</div>
